import { NSFunctions } from './functions';
import proj4_mod_name from 'proj4';

export let NSCRS = {};

NSCRS.init = function()
{
  NSCRSPrivate.init();

  this.f_convert_xy_from_EPSG3857_to_ETRS89_PT_TM06 =                                     function () { return NSCRSPrivate.f_convert_xy_from_EPSG3857_to_ETRS89_PT_TM06.apply( NSCRSPrivate, arguments ); };
  this.f_convert_xy_from_ETRS89_PT_TM06_to_EPSG3857 =                                     function () { return NSCRSPrivate.f_convert_xy_from_ETRS89_PT_TM06_to_EPSG3857.apply( NSCRSPrivate, arguments ); };
  this.f_convert_xy_from_EPSG3857_to_ETRS89_PT_TM06_rounded_with_X_DP =                   function () { return NSCRSPrivate.f_convert_xy_from_EPSG3857_to_ETRS89_PT_TM06_rounded_with_X_DP.apply( NSCRSPrivate, arguments ); };
  this.f_convert_xy_from_EPSG3857_to_ETRS89_PT_TM06_rounded_with_X_DP_in_decimeters =     function () { return NSCRSPrivate.f_convert_xy_from_EPSG3857_to_ETRS89_PT_TM06_rounded_with_X_DP_in_decimeters.apply( NSCRSPrivate, arguments ); };
  
	
	window.NSCRS_ = NSCRS;
	window.NSCRSPrivate_ = NSCRSPrivate;
	
}

let NSCRSPrivate = {
    private_objs:
    {

      CONSTS:{
			  EPSG_3857: 'EPSG:3857', // EPSG:3857
        /*
          https://spatialreference.org/ref/epsg/3763/
          https://spatialreference.org/ref/epsg/3763/proj4/
        */
        ETRS89_PT_TM06__projection: "+proj=tmerc +lat_0=39.66825833333333 +lon_0=-8.133108333333334 +k=1 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs "
      }
      
    },

    init: function()
    {
      

    },

    /**
     * 
     * @param {Array} a_xy ex: [1.1, 2.2]
     * @returns {Array} an array with transformed xy - ex: [10.1, 20.2]
     */
    f_convert_xy_from_EPSG3857_to_ETRS89_PT_TM06: function(a_xy)
    {
      let private_objs = this.private_objs;

			let a_xy_etrs89 = [];

			let proj4 = proj4_mod_name;

			let source = private_objs.CONSTS.EPSG_3857;

			let etrs89__projection = private_objs.CONSTS.ETRS89_PT_TM06__projection;

			// (source, destiny, coords)
			a_xy_etrs89 = proj4(source,etrs89__projection, a_xy);

      return a_xy_etrs89;

    },

    /**
     * 
     * @param {Array} a_xy ex: [1.1, 2.2]
     * @returns {Array} an array with transformed xy - ex: [10.1, 20.2]
     */
    f_convert_xy_from_ETRS89_PT_TM06_to_EPSG3857: function(a_xy)
    {
      let private_objs = this.private_objs;

			let a_xy_etrs89 = [];

			let proj4 = proj4_mod_name;

			let source = private_objs.CONSTS.ETRS89_PT_TM06__projection;
      
			let epsg_3853_projection = private_objs.CONSTS.EPSG_3857;

			// (source, destiny, coords)
			a_xy_etrs89 = proj4(source, epsg_3853_projection, a_xy);

      return a_xy_etrs89;

    },

    f_convert_xy_from_EPSG3857_to_ETRS89_PT_TM06_rounded_with_X_DP: function(a_xy, i_number_of_decimal_places)
    {
      let private_objs = this.private_objs;
      
			let a_xy_etrs89 = this.f_convert_xy_from_EPSG3857_to_ETRS89_PT_TM06(a_xy);

      a_xy_etrs89[0] = NSFunctions.roundNumber(a_xy_etrs89[0], i_number_of_decimal_places);
      a_xy_etrs89[1] = NSFunctions.roundNumber(a_xy_etrs89[1], i_number_of_decimal_places);

      return a_xy_etrs89;

    },

    f_convert_xy_from_EPSG3857_to_ETRS89_PT_TM06_rounded_with_X_DP_in_decimeters: function(a_xy, i_number_of_decimal_places)
    {
      let a_a_xy_etrs89 = this.f_convert_xy_from_EPSG3857_to_ETRS89_PT_TM06_rounded_with_X_DP(a_xy, i_number_of_decimal_places);
      let a_a_xy_etrs89_dcm = null;
      if(a_a_xy_etrs89 != null && a_a_xy_etrs89.length > 0)
      {
        a_a_xy_etrs89_dcm = [];
        a_a_xy_etrs89_dcm.push( a_a_xy_etrs89[0] * 10 );
        a_a_xy_etrs89_dcm.push( a_a_xy_etrs89[1] * 10 );
      }
      
      return a_a_xy_etrs89_dcm;

    }

    	
}